<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :setLoading="setLoading"
    :persistenceKey="'journals-list'"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";

import TransactionListTemplate from "../../templates/transaction-list";
import {
  FinanceTabs,
  GetIndexByTabName,
} from "../../_models/tabdata/finance/finance-tabs";
import ColumnWidth from "@/_helpers/data-grid/ColumnWidth";
import { FeatureStorage } from "../../_services/storage";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {
      setLoading: false,
      CustomerSalesRepresentativeCode: undefined,
    };
  },
  computed: {
    setScreenConfig() {
      var config = {
        title: "Journals",
        ScreenName: "Journals - All",
        selectedIndex: GetIndexByTabName("All"),
        tabs: FinanceTabs,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "JournalList",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
            },
            // rowSelect: {
            //   view: this,
            //   page: "sales-order",
            //   mode: "review",
            //   idProperty: "Code",
            // },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Orders",
                message: "Get Started, Add an Order",
              },
            },
          },

          toolbar: {
            search: false,
            columnChooser: true,
            export: false,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/journals/create",
                clickAction: {},
                buttonLocation: "left",
              },
            ],
          },
          columns: [
            {
              screenField: "Code",
              gridDataField: "JournalCode",
              label: "Journal",
              sortOrder: "desc",
              sortIndex: 0,
              allowHiding: false,
              fixed: true,
              fixedPosition: "left",
              minWidth: ColumnWidth.AccountCode.minWidth,
              width: ColumnWidth.AccountCode.width,
              showInColumnChooser: true,
              allowSearch: false,
              filterIndex: 0,
              type: "Integer",
              filterLabel: "Journal",
              filterDataField: "JournalCode",
              forceWidth: true,
            },
            {
              screenField: "JournalSearchText",
              dataField: "JournalSearchText",
              gridDataField: "JournalSearchText",
              visible: false,
              showInColumnChooser: false,
            },
            {
              screenField: "Account",
              dataField: "GLAccountCodeList",
              filterOperator: "contains",
              gridDataField: "GLAccountCodeList",
              filterDataField: "GLAccountCodeList",
              visible: false,
              showInColumnChooser: false,
              filterIndex: 2,
            },
            {
              screenField: "Date",
              gridDataField: "Date",
              filterDataField: "Date",
              minWidth: ColumnWidth.Date.minWidth,
              width: ColumnWidth.Date.width,
              filterIndex: 3,
            },
            {
              screenField: "DateCreated",
              minWidth: ColumnWidth.DateCreated.minWidth,
              width: ColumnWidth.DateCreated.width,
              filterIndex: 4,
            },
            {
              screenField: "CreatedBy",
              minWidth: ColumnWidth.Username.minWidth,
              width: ColumnWidth.Username.width,
              //   gridDataField: "CreatedBy",
              filterIndex: 5,
              dataSourceConfig: {
                endpoint: "api/Users",
                sort: {
                  selector: "Username",
                  asc: true,
                },
              },
            },
            // {
            //   screenField: "Account",
            //   visible: false,
            //   showInColumnChooser: false,
            //   filterIndex: 1,
            // },
            {
              screenField: "Narration",
              filterIndex: 1,
            },
            {
              screenField: "OrderStatus",
              gridDataField: "Status",
              filterDataField: "FriendlyStatus",
              filterIndex: 6,
              // filterDefaultValue: ["Completed"],
            },
            {
              screenField: "GridRecordEmail",
              cssClass: "padding-7",
              ReferenceNoField: "Code",
            },
            {
              screenField: "GridRecordPDFView",
              cssClass: "padding-7",
            },
            {
              screenField: "GridRecordPrint",
              cssClass: "padding-7",
              ReferenceNoField: "Code",
            },
            {
              screenField: "GridRecordEllipsisMenu",
              cssClass: "padding-7",
              allowSearch: false,
              ellipsisMenu: {
                itemAction: (data) => {
                  return [
                    {
                      menuText: "Copy",
                      data: data,
                      clickAction: this.copyJournalFromList,
                      disabled: FeatureStorage.checkPermission(
                        "Journals",
                        "create"
                      )
                        ? false
                        : true,
                    },
                  ];
                },
                keyExpr: "menuText",
                displayExpr: "menuText",
              },
            },
          ],
        },
      };

      return config;
    },
  },
  methods: {
    rowClickCallBack(e) {
      if (
        e.rowType == "data" &&
        e.column.screenField != "OrderStatus" &&
        e.column.screenField != "GridRecordPDFView" &&
        e.column.screenField != "GridRecordEmail" &&
        e.column.screenField != "GridRecordPrint" &&
        e.column.screenField != "GridRecordEllipsisMenu"
      ) {
        this.onRowClicked(e, {
          view: this,
          page: "journals",
          mode: "review",
          idProperty: "JournalCode",
        });
      }
    },
    copyJournalFromList(e) {
      this.$router.push({
        path: `/journals/create/${e.JournalCode}`,
        query: {
          copy: true,
        },
      });
    },
  },

  created() {
    this.setLoading = true;
  },
};
</script>

<style lang="scss"></style>
